import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "src/app/shared/shared.service";
import { PAGE_VIEW_TYPE } from "src/app/utility/Constants";
import { MasterService } from "src/app/pages/master/master.service";

@Component({
  selector: "app-material-return-to-godown-add",
  templateUrl: "./material-return-to-godown-add.component.html",
  styleUrls: ["./material-return-to-godown-add.component.scss"],
})
export class MaterialReturnToGodownAddComponent implements OnInit {
  isLoading = false;
  isEditMode = false;
  MaterialReturnForm!: FormGroup;
  viewType: string = PAGE_VIEW_TYPE.ADD;
  branchId: any;
  companyKey: any;
  selectedId: any;
  
  selectedPRNEntry: any; 

  siteList: any[] = [];
  filteredSites: any[] = [];
  siteSearchControl = new FormControl('');

  godownList: any[] = [];
  filteredGodowns: any[] = [];
  godownSearchControl = new FormControl('');

  productList: any[] = [];
  rowSpecificMakes: { [rowIndex: number]: any[] } = {};

  constructor(
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private _router: Router,
    public sharedService: SharedService,
    private _masterService: MasterService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.branchId = localStorage.getItem("branch");
    this.companyKey = sessionStorage.getItem("currentUser");
    
    this.initializeForm();
    this.fetchInitialDropdowns();

    this._route.queryParams.subscribe((params) => {
      this.viewType = params['viewType'] || PAGE_VIEW_TYPE.ADD;
      this.isEditMode = this.viewType === PAGE_VIEW_TYPE.UPDATE;
      this.setFormState();
    });

    if (this._route.snapshot?.params?.['id']) {
      this.selectedId = this._route.snapshot.params['id'];
      this.getReturnDetails(this.selectedId);
    } else {
      this.addProductDetails();
    }
  }

  setFormState() {
    if (this.MaterialReturnForm) {
      if (this.viewType === PAGE_VIEW_TYPE.VIEW) {
        this.MaterialReturnForm.disable({ emitEvent: false });
      } else {
        this.MaterialReturnForm.enable({ emitEvent: false });
        (this.MaterialReturnForm.get("materialReturnNo") as any)?.disable({ emitEvent: false });
      }
    }
  }

  initializeForm() {
    this.MaterialReturnForm = this.formBuilder.group({
      siteId: ["", Validators.required],
      godownId: ["", Validators.required],
      returnDate: [new Date(), Validators.required],
      materialReturnNo: ["", Validators.required],
      productDetails: this.formBuilder.array([]),
    });
  }

  // availableQtyValidator(control: AbstractControl): ValidationErrors | null {
  //   const parent = control.parent;
  //   if (!parent) return null;

  //   const returnQty = +control.value || 0;
  //   const availableQty = +parent.get("availableQty")?.value || 0;

  //   if (returnQty > availableQty) {
  //     return { qtyExceeded: true };
  //   }
  //   if (returnQty <= 0) {
  //     return { minQty: true };
  //   }
  //   return null;
  // }

  // UPDATE THIS VALIDATOR
  availableQtyValidator(control: AbstractControl): ValidationErrors | null {
    const parent = control.parent;
    if (!parent) return null;

    const returnQty = +control.value || 0;
    const availableQty = +parent.get("availableQty")?.value || 0;

    if (returnQty > availableQty) {
      return { qtyExceeded: true };
    }
    if (returnQty <= 0) {
      return { min: true }; // Changed from minQty to 'min' to perfectly match your HTML error check
    }
    return null;
  }

  createProductDetailGroup(item?: any): FormGroup {
    const isViewMode = this.viewType === PAGE_VIEW_TYPE.VIEW;
    return this.formBuilder.group({
      productId: [{ value: item?.productId || "", disabled: isViewMode }, Validators.required],
      makeId: [{ value: item?.makeId || "", disabled: isViewMode }, Validators.required],
      availableQty: [{ value: item?.availableQty || 0, disabled: true }],
      returnQty: [
        { value: item?.returnQty || "", disabled: isViewMode },
        isViewMode ? [] : [this.availableQtyValidator.bind(this), Validators.required],
      ],
      returnReason: [{ value: item?.returnReason || "", disabled: isViewMode }]
    });
  }

  // addProductDetails(item?: any) {
  //   (this.MaterialReturnForm.get("productDetails") as FormArray).push(
  //     this.createProductDetailGroup(item)
  //   );
  // }
addProductDetails(item?: any) {
    const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
    const newIndex = productArray.length;
    
    // Initialize empty array for makes at this specific row index to prevent undefined errors
    this.rowSpecificMakes[newIndex] = [];

    productArray.push(
      this.createProductDetailGroup(item)
    );
  }

  onDeleteItem(index: number) {
    (this.MaterialReturnForm.get("productDetails") as FormArray).removeAt(index);
    delete this.rowSpecificMakes[index];
  }

  // --- API / Searchable Dropdown Logic ---

  // fetchInitialDropdowns() {
  //   // Fetch Sites
  //   this.sharedService.getSites().subscribe({
  //     next: (res: any) => {
  //       this.siteList = res || [];
  //       this.filteredSites = [...this.siteList];

  //       this.siteSearchControl.valueChanges.subscribe(() => {
  //         this.filterSites();
  //       });
  //     },
  //     error: (err: any) => console.error("Failed to fetch sites:", err)
  //   });

  //   // Fetch Godowns
  //   this.sharedService.getGodowns().subscribe({
  //     next: (res: any) => {
  //       this.godownList = res || [];
  //       this.filteredGodowns = [...this.godownList];

  //       this.godownSearchControl.valueChanges.subscribe(() => {
  //         this.filterGodowns();
  //       });
  //     },
  //     error: (err: any) => console.error("Failed to fetch godowns:", err)
  //   });
  // }

fetchInitialDropdowns() {
    // 1. Fetch Sites using MasterService (same as Work Order)
    this._masterService.getAllActiveSiteData().subscribe({
      next: (res: any) => {
        this.siteList = res || [];
        this.filteredSites = [...this.siteList];

        this.siteSearchControl.valueChanges.subscribe(() => {
          this.filterSites();
        });
      },
      error: (err: any) => console.error("Failed to fetch sites:", err)
    });

    // 2. Fetch Godowns using SharedService
  //   this.sharedService.getGodowns().subscribe({
  //     next: (res: any) => {
  //       this.godownList = res?.data || res || [];
  //       this.filteredGodowns = [...this.godownList];

  //       this.godownSearchControl.valueChanges.subscribe(() => {
  //         this.filterGodowns();
  //       });
  //     },
  //     error: (err: any) => console.error("Failed to fetch godowns:", err)
  //   });
  // }
  this.sharedService.getGodowns().subscribe({
      next: (res: any) => {
        this.godownList = res?.data || res || [];
        this.filteredGodowns = [...this.godownList];

        this.godownSearchControl.valueChanges.subscribe(() => {
          this.filterGodowns();
        });
      },
      error: (err: any) => console.error("Failed to fetch godowns:", err)
    });
  }

  // filterSites() {
  //   const search = this.siteSearchControl.value?.toLowerCase() || '';
  //   if (!search) {
  //     this.filteredSites = [...this.siteList];
  //     return;
  //   }
  //   this.filteredSites = this.siteList.filter(s =>
  //     s.site_name.toLowerCase().includes(search)
  //   );
  // }
  

  // filterGodowns() {
  //   const search = this.godownSearchControl.value?.toLowerCase() || '';
  //   if (!search) {
  //     this.filteredGodowns = [...this.godownList];
  //     return;
  //   }
  //   this.filteredGodowns = this.godownList.filter(g =>
  //     g.godown_name.toLowerCase().includes(search)
  //   );
  // }

  filterSites() {
    const search = this.siteSearchControl.value?.toLowerCase() || '';
    if (!search) {
      this.filteredSites = [...this.siteList];
      return;
    }
    this.filteredSites = this.siteList.filter(s =>
      (s.site_name || s.siteName || '').toLowerCase().includes(search)
    );
  }

  filterGodowns() {
    const search = this.godownSearchControl.value?.toLowerCase() || '';
    if (!search) {
      this.filteredGodowns = [...this.godownList];
      return;
    }
    this.filteredGodowns = this.godownList.filter(g =>
      (g.warehouseName||g.godown_name || g.godownName || '').toLowerCase().includes(search)
    );
  }

 

  // onSiteSelect(siteId: any) {
  //   const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
    
  //   // Clear existing rows (Product, Make, and Qty fields)
  //   while (productArray.length !== 0) {
  //     productArray.removeAt(0);
  //   }
    
  //   // Clear out row makes tracking object
  //   this.rowSpecificMakes = {}; 
    
  //   // Re-initialize with one empty row
  //   this.addProductDetails(); 

  //   // Fetch Products with available stock > 0
  //   this.sharedService.getProductsBySite(siteId).subscribe({
  //     next: (res: any) => {
  //       this.productList = res || [];
  //     },
  //     error: (err: any) => console.error("Failed to fetch products with stock:", err)
  //   });
  // }

  onSiteSelect(siteId: any) {
    console.log("1. Site Selected. Site ID is: ", siteId);
    const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
    
    // 1. Clear existing rows (Product, Make, and Qty fields)
    while (productArray.length !== 0) {
      productArray.removeAt(0);
    }
    
    // 2. Clear out row makes tracking object
    this.rowSpecificMakes = {}; 
    
    // 3. Re-initialize with one empty row
    this.addProductDetails(); 

    // 4. Fetch Products with available stock > 0
    this.sharedService.getProductsBySite(siteId).subscribe({
      next: (res: any) => {
        // Fallback checks just in case your backend wraps the array in a "data" object
        this.productList = res?.data || res || [];
        console.log("Fetched Products: ", this.productList); // <-- Check your browser console!
      },
      error: (err: any) => {
        console.error("Failed to fetch products with stock:", err);
        this.productList = [];
      }
    });
  }
  // onSiteSelect(siteId: any) {
  //   const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
    
  //   // Clear existing rows (Product, Make, and Qty fields)
  //   while (productArray.length !== 0) {
  //     productArray.removeAt(0);
  //   }
    
  //   // Clear out row makes tracking object
  //   this.rowSpecificMakes = {}; 
    
  //   // Re-initialize with one empty row
  //   this.addProductDetails(); 

  //   // Fetch Products with available stock > 0
  //   this.sharedService.getProductsBySite(siteId).subscribe({
  //     next: (res: any) => {
  //       this.productList = res || [];
  //     },
  //     error: (err: any) => console.error("Failed to fetch products with stock:", err)
  //   });
  // }

  // onSiteSelect(siteId: any) {
  //   const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
  //   while (productArray.length !== 0) productArray.removeAt(0);
    
  //   // Clear out row makes tracking object
  //   this.rowSpecificMakes = {}; 
    
  //   this.addProductDetails(); 

  //   this.sharedService.getProductsBySite(siteId).subscribe({
  //     next: (res: any) => this.productList = res || [],
  //     error: (err: any) => console.error("Failed to fetch products:", err)
  //   });
  // }

  onProductSelect(productId: any, rowIndex: number) {
    const siteId = this.MaterialReturnForm.get('siteId')?.value;
    
    this.sharedService.getMakesByProduct(productId, siteId).subscribe({
      next: (res: any) => {
        this.rowSpecificMakes[rowIndex] = res || [];
        const group = (this.MaterialReturnForm.get("productDetails") as FormArray).at(rowIndex) as FormGroup;
        group.patchValue({ makeId: null, availableQty: 0, returnQty: null });
      },
      error: (err: any) => console.error("Failed to fetch makes:", err)
    });
  }
  

  onMakeSelect(makeId: any, rowIndex: number) {
    const siteId = this.MaterialReturnForm.get('siteId')?.value;
    const group = (this.MaterialReturnForm.get("productDetails") as FormArray).at(rowIndex) as FormGroup;
    const productId = group.get('productId')?.value;

    console.log(`Sending to API -> Site: ${siteId}, Product: ${productId}, Make: ${makeId}`); // <-- ADD THIS LOG

    if (!siteId || !productId || !makeId) return;

    this.sharedService.getAvailableStock(siteId, productId, makeId).subscribe({
      next: (res: any) => {
        console.log("Available Stock API Response:", res);
        const available = res?.availableQty || 0;
        group.get("availableQty")?.setValue(available);
        group.get("returnQty")?.updateValueAndValidity();
      },
      error: (err: any) => console.error("Failed to fetch available stock:", err)
    });
  }
  // onMakeSelect(makeId: any, rowIndex: number) {
  //   const siteId = this.MaterialReturnForm.get('siteId')?.value;
  //   const group = (this.MaterialReturnForm.get("productDetails") as FormArray).at(rowIndex) as FormGroup;
  //   const productId = group.get('productId')?.value;

  //   if (!siteId || !productId || !makeId) return;

  //   this.sharedService.getAvailableStock(siteId, productId, makeId).subscribe({
  //     next: (res: any) => {
  //       const available = res?.availableQty || 0;
  //       group.get("availableQty")?.setValue(available);
  //       group.get("returnQty")?.updateValueAndValidity();
  //     //  row.patchValue({ availableQty: response.availableQty || 0 });
  //     },
  //     error: (err: any) => console.error("Failed to fetch available stock:", err)
  //   });
  // }

  getMakesForProduct(rowIndex: number): any[] {
    return this.rowSpecificMakes[rowIndex] || [];
  }

  // --- SAVE LOGIC ---

  getFormValue() {
    const formValue = { ...this.MaterialReturnForm.value };

    Object.keys(this.MaterialReturnForm.controls).forEach((key) => {
      const control = this.MaterialReturnForm.get(key);
      if (control?.disabled) {
        formValue[key] = control.value;
      }
    });

    const productDetailsArray = this.MaterialReturnForm.get("productDetails") as FormArray;
    formValue.productDetails = productDetailsArray.controls.map((control) => {
      const productValue: any = {};
      Object.keys((control as FormGroup).controls).forEach((productKey) => {
        const productControl = control.get(productKey);
        productValue[productKey] = productControl?.value;
      });
      return productValue;
    });

    return formValue;
  }

  onSave() {
    if (this.MaterialReturnForm.valid) {
      const formData = this.getFormValue();
      if (this.viewType === PAGE_VIEW_TYPE.UPDATE) {
        this.updateGodownReturn(this.selectedId, formData);
      } else if (this.viewType === PAGE_VIEW_TYPE.ADD) {
        this.createGodownReturn(formData);
      }
    }
  }

  onSaveAsDraft() {
    if (this.MaterialReturnForm.valid) {
      const formData = { ...this.getFormValue(), isDraft: true };
      if (this.viewType === PAGE_VIEW_TYPE.UPDATE) {
        this.updateGodownReturn(this.selectedId, formData);
      } else if (this.viewType === PAGE_VIEW_TYPE.ADD) {
        this.createGodownReturn(formData);
      }
    }
  }

  createGodownReturn(formData: any) {
    this.isLoading = true;
    let company = JSON.parse(this.companyKey || '{}');
    const { returnDate, siteId, godownId, isDraft } = formData;

    const detailList = formData.productDetails.map((prod: any) => ({
      productKey: prod.productId,
      makeKey: prod.makeId,
      returnQty: prod.returnQty,
      reason: prod.returnReason
    }));

    const payload = {
      branchKey: Number(this.branchId),
      companyKey: Number(company.companyKey),
      siteKey: siteId,
      godownKey: godownId,
      matReturnDate: returnDate.toISOString(),    // Changed from returnDate
      draft: isDraft || false,                    // Changed from isDraft
      matReturnGodownDetRequestList: detailList   // Changed from details
    };

    this.sharedService.createGodownReturn(payload).subscribe({
      next: (response: any) => {
        this.snackBar.open("Godown return created successfully", "Cancel", { duration: 3000, verticalPosition: "top", panelClass: ["if-success"] });
        this.isLoading = false;
        this.onCancel();
      },
      error: (err: any) => {
        this.snackBar.open("Failed to create request", "Cancel", { duration: 5000, verticalPosition: "top", panelClass: ["if-error"] });
        this.isLoading = false;
      }
    });
  }

  updateGodownReturn(id: string, formData: any) {
    this.isLoading = true;
    let company = JSON.parse(this.companyKey || '{}');
    const { returnDate, siteId, godownId, isDraft } = formData;

    const detailList = formData.productDetails.map((prod: any) => ({
      productKey: prod.productId,
      makeKey: prod.makeId,
      returnQty: prod.returnQty,
      reason: prod.returnReason
    }));

    const payload = {
      id: id,
      branchKey: Number(this.branchId),
      companyKey: Number(company.companyKey),
      siteKey: siteId,
      godownKey: godownId,
      returnDate: returnDate.toISOString(),
      isDraft: isDraft || false,
      details: detailList
    };

    this.sharedService.updateGodownReturn(id, payload).subscribe({
      next: (response: any) => {
        this.snackBar.open("Godown return updated successfully", "Cancel", { duration: 3000, verticalPosition: "top", panelClass: ["if-success"] });
        this.isLoading = false;
        this.onCancel();
      },
      error: (err: any) => {
        this.snackBar.open("Failed to update request", "Cancel", { duration: 5000, verticalPosition: "top", panelClass: ["if-error"] });
        this.isLoading = false;
      }
    });
  }

  getReturnDetails(id: string) {
    this.isLoading = true;
    this.sharedService.getGodownReturnById(id).subscribe({
      next: (response: any) => {
        const data = response.data || response;
        this.selectedPRNEntry = data;
        this.buildFormWithGodownData(data);
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error("Failed to fetch details:", err);
        this.isLoading = false;
      }
    });
  }

  buildFormWithGodownData(data: any) {
    if (!this.MaterialReturnForm) {
      this.initializeForm();
    }

    this.MaterialReturnForm.patchValue({
      siteId: data.siteKey,
      godownId: data.godownKey,
      returnDate: data.returnDate ? new Date(data.returnDate) : new Date(),
      materialReturnNo: data.materialReturnNo || ""
    });

    this.setFormState();

    if (data.siteKey) {
      this.sharedService.getProductsBySite(data.siteKey).subscribe({
        next: (products: any) => {
          this.productList = products;

          const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
          productArray.clear();

          if (data.details && data.details.length > 0) {
            data.details.forEach((item: any, index: number) => {
              
              this.sharedService.getMakesByProduct(item.productKey, data.siteKey).subscribe((makesRes: any) => {
                  this.rowSpecificMakes[index] = makesRes || [];
              });

              this.addProductDetails({
                productId: item.productKey,
                makeId: item.makeKey,
                availableQty: item.availableQty, 
                returnQty: item.returnQty,
                returnReason: item.reason
              });
            });
          }
        },
        error: (err: any) => console.error("Failed to fetch products for edit:", err)
      });
    }
  }

  onCancel() {
    this._router.navigate([`/materialReturn/materialReturnToGodown`]);
  }
}

// import { Component, OnInit } from "@angular/core";
// import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
// import { MatDialog } from "@angular/material/dialog";
// import { MatSnackBar } from "@angular/material/snack-bar";
// import { ActivatedRoute, Router } from "@angular/router";
// import { SharedService } from "src/app/shared/shared.service";
// import { PAGE_VIEW_TYPE } from "src/app/utility/Constants";

// @Component({
//   selector: "app-material-return-to-godown-add",
//   templateUrl: "./material-return-to-godown-add.component.html",
//   styleUrls: ["./material-return-to-godown-add.component.scss"],
// })
// export class MaterialReturnToGodownAddComponent implements OnInit {
//   isLoading = false;
//   isEditMode = false;
//   MaterialReturnForm!: FormGroup;
//   viewType: string = PAGE_VIEW_TYPE.ADD;
//   branchId: any;
//   companyKey: any;
//   selectedId: any;
  
//   selectedPRNEntry: any; 

//   siteList: any = [];
//   godownList: any = [];
//   productList: any = [];
//   rowSpecificMakes: { [rowIndex: number]: any[] } = {};

//   constructor(
//     public formBuilder: FormBuilder,
//     public dialog: MatDialog,
//     private _route: ActivatedRoute,
//     private _router: Router,
//     public sharedService: SharedService,
//     private snackBar: MatSnackBar
//   ) {}

//   ngOnInit(): void {
//     this.branchId = localStorage.getItem("branch");
//     this.companyKey = sessionStorage.getItem("currentUser");
    
//     this.initializeForm();
//     this.fetchInitialDropdowns();

//     this._route.queryParams.subscribe((params) => {
//       this.viewType = params['viewType'] || PAGE_VIEW_TYPE.ADD;
//       this.isEditMode = this.viewType === PAGE_VIEW_TYPE.UPDATE;
//       this.setFormState();
//     });

//     if (this._route.snapshot?.params?.['id']) {
//       this.selectedId = this._route.snapshot.params['id'];
//       this.getReturnDetails(this.selectedId);
//     } else {
//       this.addProductDetails();
//     }
//   }

//   setFormState() {
//     if (this.MaterialReturnForm) {
//       if (this.viewType === PAGE_VIEW_TYPE.VIEW) {
//         this.MaterialReturnForm.disable({ emitEvent: false });
//       } else {
//         this.MaterialReturnForm.enable({ emitEvent: false });
//         (this.MaterialReturnForm.get("materialReturnNo") as any)?.disable({ emitEvent: false });
//       }
//     }
//   }

//   initializeForm() {
//     this.MaterialReturnForm = this.formBuilder.group({
//       siteId: ["", Validators.required],
//       godownId: ["", Validators.required],
//       returnDate: [new Date(), Validators.required],
//       materialReturnNo: ["", Validators.required],
//       productDetails: this.formBuilder.array([]),
//     });
//   }

//   availableQtyValidator(control: AbstractControl): ValidationErrors | null {
//     const parent = control.parent;
//     if (!parent) return null;

//     const returnQty = +control.value || 0;
//     const availableQty = +parent.get("availableQty")?.value || 0;

//     if (returnQty > availableQty) {
//       return { qtyExceeded: true };
//     }
//     if (returnQty <= 0) {
//       return { minQty: true };
//     }
//     return null;
//   }

//   createProductDetailGroup(item?: any): FormGroup {
//     const isViewMode = this.viewType === PAGE_VIEW_TYPE.VIEW;
//     return this.formBuilder.group({
//       productId: [{ value: item?.productId || "", disabled: isViewMode }, Validators.required],
//       makeId: [{ value: item?.makeId || "", disabled: isViewMode }, Validators.required],
//       availableQty: [{ value: item?.availableQty || 0, disabled: true }],
//       returnQty: [
//         { value: item?.returnQty || "", disabled: isViewMode },
//         isViewMode ? [] : [this.availableQtyValidator.bind(this), Validators.required],
//       ],
//       returnReason: [{ value: item?.returnReason || "", disabled: isViewMode }]
//     });
//   }

//   addProductDetails(item?: any) {
//     (this.MaterialReturnForm.get("productDetails") as FormArray).push(
//       this.createProductDetailGroup(item)
//     );
//   }

//   onDeleteItem(index: number) {
//     (this.MaterialReturnForm.get("productDetails") as FormArray).removeAt(index);
//     delete this.rowSpecificMakes[index];
//   }

//   // --- API / Dropdown Logic ---

//   fetchInitialDropdowns() {
//     this.sharedService.getSites().subscribe({
//       next: (res: any) => this.siteList = res || [],
//       error: (err: any) => console.error("Failed to fetch sites:", err)
//     });

//     this.sharedService.getGodowns().subscribe({
//       next: (res: any) => this.godownList = res || [],
//       error: (err: any) => console.error("Failed to fetch godowns:", err)
//     });
//   }

//   onSiteSelect(siteId: any) {
//     const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
//     while (productArray.length !== 0) productArray.removeAt(0);
//     this.rowSpecificMakes = {};
//     this.addProductDetails(); 

//     this.sharedService.getProductsBySite(siteId).subscribe({
//       next: (res: any) => this.productList = res || [],
//       error: (err: any) => console.error("Failed to fetch products:", err)
//     });
//   }

//   onProductSelect(productId: any, rowIndex: number) {
//     const siteId = this.MaterialReturnForm.get('siteId')?.value;
    
//     this.sharedService.getMakesByProduct(productId, siteId).subscribe({
//       next: (res: any) => {
//         this.rowSpecificMakes[rowIndex] = res || [];
//         const group = (this.MaterialReturnForm.get("productDetails") as FormArray).at(rowIndex) as FormGroup;
//         group.patchValue({ makeId: null, availableQty: 0, returnQty: null });
//       },
//       error: (err: any) => console.error("Failed to fetch makes:", err)
//     });
//   }


//   getMakesForProduct(rowIndex: number): any[] {
//     return this.rowSpecificMakes[rowIndex] || [];
//   }

//   // --- SAVE LOGIC ---

//   getFormValue() {
//     const formValue = { ...this.MaterialReturnForm.value };

//     Object.keys(this.MaterialReturnForm.controls).forEach((key) => {
//       const control = this.MaterialReturnForm.get(key);
//       if (control?.disabled) {
//         formValue[key] = control.value;
//       }
//     });

//     const productDetailsArray = this.MaterialReturnForm.get("productDetails") as FormArray;
//     formValue.productDetails = productDetailsArray.controls.map((control) => {
//       const productValue: any = {};
//       Object.keys((control as FormGroup).controls).forEach((productKey) => {
//         const productControl = control.get(productKey);
//         productValue[productKey] = productControl?.value;
//       });
//       return productValue;
//     });

//     return formValue;
//   }

//   onSave() {
//     if (this.MaterialReturnForm.valid) {
//       const formData = this.getFormValue();
//       if (this.viewType === PAGE_VIEW_TYPE.UPDATE) {
//         this.updateGodownReturn(this.selectedId, formData);
//       } else if (this.viewType === PAGE_VIEW_TYPE.ADD) {
//         this.createGodownReturn(formData);
//       }
//     }
//   }

//   onSaveAsDraft() {
//     if (this.MaterialReturnForm.valid) {
//       const formData = { ...this.getFormValue(), isDraft: true };
//       if (this.viewType === PAGE_VIEW_TYPE.UPDATE) {
//         this.updateGodownReturn(this.selectedId, formData);
//       } else if (this.viewType === PAGE_VIEW_TYPE.ADD) {
//         this.createGodownReturn(formData);
//       }
//     }
//   }

//   createGodownReturn(formData: any) {
//     this.isLoading = true;
//     let company = JSON.parse(this.companyKey || '{}');
//     const { returnDate, siteId, godownId, isDraft } = formData;

//     const detailList = formData.productDetails.map((prod: any) => ({
//       productKey: prod.productId,
//       makeKey: prod.makeId,
//       returnQty: prod.returnQty,
//       reason: prod.returnReason
//     }));

//     const payload = {
//       branchKey: Number(this.branchId),
//       companyKey: Number(company.companyKey),
//       siteKey: siteId,
//       godownKey: godownId,
//       returnDate: returnDate.toISOString(),
//       isDraft: isDraft || false,
//       details: detailList
//     };

//     this.sharedService.createGodownReturn(payload).subscribe({
//       next: (response: any) => {
//         this.snackBar.open("Godown return created successfully", "Cancel", { duration: 3000, verticalPosition: "top", panelClass: ["if-success"] });
//         this.isLoading = false;
//         this.onCancel();
//       },
//       error: (err: any) => {
//         this.snackBar.open("Failed to create request", "Cancel", { duration: 5000, verticalPosition: "top", panelClass: ["if-error"] });
//         this.isLoading = false;
//       }
//     });
//   }

//   updateGodownReturn(id: string, formData: any) {
//     this.isLoading = true;
//     let company = JSON.parse(this.companyKey || '{}');
//     const { returnDate, siteId, godownId, isDraft } = formData;

//     const detailList = formData.productDetails.map((prod: any) => ({
//       productKey: prod.productId,
//       makeKey: prod.makeId,
//       returnQty: prod.returnQty,
//       reason: prod.returnReason
//     }));

//     const payload = {
//       id: id,
//       branchKey: Number(this.branchId),
//       companyKey: Number(company.companyKey),
//       siteKey: siteId,
//       godownKey: godownId,
//       returnDate: returnDate.toISOString(),
//       isDraft: isDraft || false,
//       details: detailList
//     };

//     this.sharedService.updateGodownReturn(id, payload).subscribe({
//       next: (response: any) => {
//         this.snackBar.open("Godown return updated successfully", "Cancel", { duration: 3000, verticalPosition: "top", panelClass: ["if-success"] });
//         this.isLoading = false;
//         this.onCancel();
//       },
//       error: (err: any) => {
//         this.snackBar.open("Failed to update request", "Cancel", { duration: 5000, verticalPosition: "top", panelClass: ["if-error"] });
//         this.isLoading = false;
//       }
//     });
//   }

//   getReturnDetails(id: string) {
//     this.isLoading = true;
//     this.sharedService.getGodownReturnById(id).subscribe({
//       next: (response: any) => {
//         const data = response.data || response;
//         this.selectedPRNEntry = data;
//         this.buildFormWithGodownData(data);
//         this.isLoading = false;
//       },
//       error: (err: any) => {
//         console.error("Failed to fetch details:", err);
//         this.isLoading = false;
//       }
//     });
//   }

//   buildFormWithGodownData(data: any) {
//     if (!this.MaterialReturnForm) {
//       this.initializeForm();
//     }

//     this.MaterialReturnForm.patchValue({
//       siteId: data.siteKey,
//       godownId: data.godownKey,
//       returnDate: data.returnDate ? new Date(data.returnDate) : new Date(),
//       materialReturnNo: data.materialReturnNo || ""
//     });

//     this.setFormState();

//     if (data.siteKey) {
//       this.sharedService.getProductsBySite(data.siteKey).subscribe({
//         next: (products: any) => {
//           this.productList = products;

//           const productArray = this.MaterialReturnForm.get("productDetails") as FormArray;
//           productArray.clear();

//           if (data.details && data.details.length > 0) {
//             data.details.forEach((item: any, index: number) => {
              
//               this.sharedService.getMakesByProduct(item.productKey, data.siteKey).subscribe((makesRes: any) => {
//                   this.rowSpecificMakes[index] = makesRes || [];
//               });

//               this.addProductDetails({
//                 productId: item.productKey,
//                 makeId: item.makeKey,
//                 availableQty: item.availableQty, 
//                 returnQty: item.returnQty,
//                 returnReason: item.reason
//               });
//             });
//           }
//         },
//         error: (err: any) => console.error("Failed to fetch products for edit:", err)
//       });
//     }
//   }

//   onCancel() {
//     this._router.navigate([`/materialReturn/materialReturnToGodown`]);
//   }
// }

